import { Outlet } from 'react-router-dom';
import { SearchProvider } from '~/components/searchTable/searchControlBar/SearchContext';
import { usePathParams } from '~/hooks/usePathParams';
import { claimParamsSchema } from './claimParamsSchema';

export default function ClaimsLayout() {
  const { claimType } = usePathParams(claimParamsSchema);

  // key forces re-render on claimType change so filter definitions reload
  return (
    <SearchProvider key={claimType} entity={claimType}>
      <Outlet />
    </SearchProvider>
  );
}
